import { Popover, useStyles } from '@signavio/ui';
import { jsx as _jsx } from "react/jsx-runtime";
function Disable({
  children,
  disabled = true,
  hint,
  position = 'top'
}) {
  const styles = useStyles(defaultStyles, {});
  if (!disabled) {
    return /*#__PURE__*/_jsx("div", {
      "data-testid": "disable-layer",
      ...styles,
      children: children
    });
  }
  if (!hint) {
    return /*#__PURE__*/_jsx("div", {
      ...styles({
        '&disabled': true
      }),
      "data-testid": "disable-layer",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Popover, {
    position: position,
    popover: hint,
    children: /*#__PURE__*/_jsx("div", {
      ...styles({
        '&disabled': true
      }),
      "data-testid": "disable-layer",
      children: children
    })
  });
}
const defaultStyles = {
  pointerEvents: 'all',
  '&disabled': {
    opacity: 0.5,
    pointerEvents: 'none'
  }
};
export default Disable;